import {
  IconExclamationTriangleOutline,
  IconFileWithItemsOutline,
} from '@iwoca/icons';
import { Card } from '@iwoca/orion';
import clsx from 'clsx';
import { TDocRequirementReview } from '../../DocumentGroup/DocumentGroup';
import fileStatusStyles from '../FileStatusGroup.module.css';
import { MissingCoverages } from '../MissingCoverages/MissingCoverages';
import styles from './MissingDocumentsGroup.module.css';

type TProps = {
  coverages?: TDocRequirementReview['bank_account_coverages'];
};

// UK-only box — never rendered under DE, so its labels are plain strings.
export const MissingDocumentsGroup = ({ coverages }: TProps) => {
  const coveragesToShow = coverages?.filter(
    (coverage) => coverage.missing_coverages.length > 0,
  );

  return (
    <Card
      data-testid="status-group-missing"
      className={clsx(fileStatusStyles.statusGroup, fileStatusStyles.rejected)}
    >
      <div className={fileStatusStyles.fileList}>
        {coveragesToShow && coveragesToShow.length > 0 ? (
          <MissingCoverages
            coverages={coveragesToShow}
            statusGroup="rejected"
          />
        ) : (
          <div className={styles.genericMessage}>
            <div className={styles.header}>
              <IconFileWithItemsOutline width={20} height={20} />
              <p className={styles.title}>Missing documents</p>
            </div>
            <p className={styles.body}>
              A few more documents are required before we can continue. Check
              the email we sent you for the details.
            </p>
          </div>
        )}
      </div>
      <div className={fileStatusStyles.status}>
        <IconExclamationTriangleOutline
          data-testid="missing-icon"
          className={fileStatusStyles.icon}
        />
        <p className={fileStatusStyles.statusText}>Missing</p>
      </div>
    </Card>
  );
};
